import { data } from '../../svg/FormatStrikethrough/data';
import { makeIcon } from '../makeIcon';

export const FormatStrikethrough = makeIcon(data, 'format_strikethrough', 'FormatStrikethrough');

export default FormatStrikethrough;
